var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-body"},[_c('Sidebar'),_vm._v(" "),_c('main',{staticClass:"main"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),(_vm.loadingUser)?_c('router-view'):_vm._e()],1),_vm._v(" "),_c('AppFooter')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c1abbb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = OVeY
// module chunks = 1